import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './activity-details-price.reducer';

export const ActivityDetailsPriceDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const activityDetailsPriceEntity = useAppSelector(state => state.activityDetailsPrice.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="activityDetailsPriceDetailsHeading">
          <Translate contentKey="activitiesApp.activityDetailsPrice.detail.title">ActivityDetailsPrice</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{activityDetailsPriceEntity.id}</dd>
          <dt>
            <span id="fromPax">
              <Translate contentKey="activitiesApp.activityDetailsPrice.fromPax">From Pax</Translate>
            </span>
          </dt>
          <dd>{activityDetailsPriceEntity.fromPax}</dd>
          <dt>
            <span id="toPax">
              <Translate contentKey="activitiesApp.activityDetailsPrice.toPax">To Pax</Translate>
            </span>
          </dt>
          <dd>{activityDetailsPriceEntity.toPax}</dd>
          <dt>
            <span id="price">
              <Translate contentKey="activitiesApp.activityDetailsPrice.price">Price</Translate>
            </span>
          </dt>
          <dd>{activityDetailsPriceEntity.price}</dd>
          <dt>
            <Translate contentKey="activitiesApp.activityDetailsPrice.activity">Activity</Translate>
          </dt>
          <dd>{activityDetailsPriceEntity.activity ? activityDetailsPriceEntity.activity.name : ''}</dd>
        </dl>
        <Button tag={Link} to="/activity-details-price" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/activity-details-price/${activityDetailsPriceEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ActivityDetailsPriceDetail;
